<!-- About -->
<template>
  <div class="About">
    <HelloWorld />
    <div class="abouttu">
      <img src="../assets/image/about.jpg" alt />
    </div>
    <div class="section1">
      <h3>公司简介</h3>
      <p>河南融商互联科技有限公司，于2017年4月成立，是一家专注于3C场景新零售SaaS的运营服务平台，并获得ZOL中关村在线重点战略投资</p>
      <br />
      <p>
        融商互联立足于3C产业互联网领域，秉承“让3C零售更便捷”的行业使命，联手中关村在线领先的互联网技术和资源优势，以SaaS链接B端，以运营赋能客户，通过
        “大数据、云计算、供应链服务、知识服务、品牌服务、消费金融、增值业务”等资源的运营实现平台价值。全面为3C终端零售客户提供“以客户为中心、以价值为核心”的产业路由器服务。
      </p>
      <br />
      <p>
        目前已经顺畅服务于近3000家大中小零售终端，系统日交易流水2000万元，年交易流水近100亿元，正努力实现“成就3C场景最有价值的新零售SaaS运营服务平台”
        的宏大愿景！
      </p>
      <br />
      <!-- <h4 style="margin:40px 0 20px;font-size:22px;">联系方式</h4>
      <p>公司电话：15617953373 <span style="color:#999999">（工作时间：周一至周日 9:00-18:00）</span></p>
      <p>公司邮箱：erpservice@zol.com.cm</p>
      <p>公司地址：河南省郑州市紫荆山路57号裕鸿国际C座1606</p>-->
    </div>
    <div class="section11">
      <h2>企业文化</h2>
      <div class="section2">
        <img src="../assets/image/c3a0e.png" alt />
      </div>
    </div>
    <h4 style="margin:50px 20px;font-size:30px; text-align: center;">联系方式</h4>
    <div class="section3">
      <div>
        <img src="../assets/image/1c45e4b.png" alt />
        <br />
        <br />
        <p>15617953373</p>
        <p>（工作时间：周一至周日 9:00-18:00）</p>
      </div>
      <div>
        <img src="../assets/image/fd420.png" alt />
        <br />
        <br />
        <p>河南省郑州市</p>
        <p>紫荆山路57号裕鸿国际C座1606</p>
      </div>
      <div>
        <img src="../assets/image/19ed06.png" alt />
        <br />
        <br />
        <p style=" margin-top: 30px;">2404139173@qq.com</p>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import HelloWorld from "@/components/top-header";
import Footer from "@/components/footer";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    HelloWorld,
    Footer,
  },
  data() {
    //这里存放数据
    return {};
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.abouttu {
  width: 100%;
   margin-top: 70px;
  img {
    width: 100%;
  }
}
.section1 {
  width: 1000px;
  height: 400px;
  margin: 0px auto;
  // border: 1px solid red;
  padding-top: 50px;
  h3 {
    text-align: center;
    margin-bottom: 50px;
    font-size: 30px;
  }
  p {
    text-align: left;
    font-size: 14px;
    line-height: 25px;
    color: #666666;
  }
}
.section11 {
  width: 100%;
  background-color: #fafafa;
  padding-top: 50px;
  padding-bottom: 50px;
  h2 {
    text-align: center;
    margin-bottom: 30px;
    font-size: 30px;
  }
  .section2 {
    width: 1000px;
    // height: 400px;
    margin: 0px auto;
    // border: 1px solid red;
    padding-top: 50px;
    img {
      width: 100%;
    }
  }
}
.section3 {
  width: 1000px;
  height: 300px;
  margin: 0px auto;
  // border: 1px solid red;
  display: flex;
  justify-content: space-between;
  div {
    width: 30%;
    // border: 1px solid red;
    height: 200px;
    text-align: center;
    p {
      margin: 5px 0px;
    }
  }
}
@media screen and (max-width: 1200px) {
  .About {
    width: 1200px;
    // border: 1px solid black;
    // background-color: red;
    // height: 560px;
  }
}
</style>